import { getAuth } from 'firebase/auth';

export const getIdToken = (): Promise<string> => {
    const authUser = getAuth().currentUser;
    if (!authUser) throw new Error('No user logged in');
    return authUser.getIdToken();
};
